'use client';

import { useSyncExternalStore } from 'react';

/** Tabs under the product (Figma „Tabs“ 60137:8036); the URL hash selects the tab. */
export const PRODUCT_TABS = ['popis', 'hodnotenia', 'na-stiahnutie'] as const;
export type ProductTab = (typeof PRODUCT_TABS)[number];

/** id of the element the tab bar and the panels sit in – target of the scroll after `showProductTab`. */
export const PRODUCT_TABS_ANCHOR = 'product-tabs';

const subscribe = (onChange: () => void) => {
  window.addEventListener('hashchange', onChange);
  return () => window.removeEventListener('hashchange', onChange);
};

const readTab = () => PRODUCT_TABS.find(tab => `#${tab}` === window.location.hash) ?? null;

/** Tab selected by the URL hash, `null` when the hash names none (the first available tab applies). */
export function useProductTabFromUrl(): ProductTab | null {
  return useSyncExternalStore(subscribe, readTab, () => null);
}

/** Selects the tab (hash, no history entry) and scrolls the tab bar into view when asked to. */
export function showProductTab(tab: ProductTab, { scroll = true }: { scroll?: boolean } = {}) {
  window.history.replaceState(null, '', `#${tab}`);
  window.dispatchEvent(new HashChangeEvent('hashchange'));
  if (scroll) {
    document.getElementById(PRODUCT_TABS_ANCHOR)?.scrollIntoView({ behavior: 'smooth' });
  }
}
